<template>
  <v-container fluid>
    <v-layout align-start>
      <v-flex>
        <!-- Modern Page Header -->
        <div class="page-header mb-6">
          <div class="d-flex align-center">
            <v-icon large color="primary" class="mr-3">business</v-icon>
            <div>
              <h1 class="text-h4 font-weight-bold grey--text text--darken-3 mb-0">Unidades de Negocio</h1>
              <span class="text-subtitle-1 grey--text">Administra y configura las unidades operativas de la
                empresa</span>
            </div>
          </div>
        </div>

        <v-card class="modern-card" elevation="2">
          <v-data-table :headers="headers" :items="bussinessUnit" :search="search" class="modern-table" fixed-header
            height="60vh">
            <template v-slot:top>
              <v-toolbar flat color="transparent" class="px-2">
                <v-badge color="primary" :content="bussinessUnit.length" overlap class="mr-4">
                  <span class="text-h6 font-weight-medium">Unidades</span>
                </v-badge>

                <v-spacer></v-spacer>

                <v-text-field v-model="search" prepend-inner-icon="search" label="Buscar unidad..." outlined dense
                  hide-details class="search-field mr-4" rounded></v-text-field>

                <v-btn color="primary" depressed rounded class="px-6 font-weight-bold" @click="openCreateDialog()">
                  <v-icon left>add</v-icon>
                  Nueva Unidad
                </v-btn>
              </v-toolbar>
            </template>

            <template v-slot:[`item.id`]="{ item }">
              <v-chip small label color="primary" outlined class="font-weight-bold px-3">
                {{ item.id }}
              </v-chip>
            </template>

            <template v-slot:[`item.status_id`]="{ item }">
              <v-switch v-model="item.status_id" :true-value="1" :false-value="2" color="success" dense
                hide-details @change="toggleStatus(item)" :loading="item.loadingStatus">
                <template v-slot:label>
                  <v-chip x-small :color="item.status_id === 1 ? 'success' : 'grey'" dark class="font-weight-bold">
                    {{ item.status_id === 1 ? 'ACTIVO' : 'INACTIVO' }}
                  </v-chip>
                </template>
              </v-switch>
            </template>

            <template v-slot:[`item.description_company`]="{ item }">
              <div class="d-flex align-center">
                <v-avatar size="24" color="grey lighten-4" class="mr-2">
                  <v-icon x-small color="grey darken-1">corporate_fare</v-icon>
                </v-avatar>
                <span class="font-weight-medium grey--text text--darken-2">
                  {{ item.description_company }}
                </span>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex justify-end">
                <v-btn icon color="primary" @click="editItem(item)" class="mx-1" title="Editar">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon color="teal lighten-2" @click="ars(item)" class="mx-1" title="Planes ARS">
                  <v-icon>verified_user</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="deleteItem(item)" class="mx-1" title="Eliminar">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:no-data>
              <v-row justify="center" class="pt-10">
                <v-icon size="80" color="grey lighten-2">business_off</v-icon>
              </v-row>
              <v-row justify="center" class="pb-10 grey--text">No se encontraron unidades de negocio</v-row>
            </template>
          </v-data-table>
        </v-card>

        <!-- Dialogo de Creacion/Edicion (Modernizado) -->
        <v-dialog v-model="dialog" max-width="900px" transition="dialog-bottom-transition" persistent>
          <v-card class="modern-card overflow-hidden">
            <v-toolbar flat color="primary" dark>
              <v-icon class="mr-2">{{ editedIndex === -1 ? 'add_business' : 'edit' }}</v-icon>
              <v-toolbar-title class="font-weight-bold">{{ formTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="close"><v-icon>close</v-icon></v-btn>
            </v-toolbar>

            <v-card-text class="pa-6">
              <v-row v-if="loading" justify="center" class="pa-10">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="8">
                  <div class="text-overline grey--text mb-4">Información General</div>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete v-model="newBussiness.company_id" :items="itemsCompany" label="Empresa / Compañía"
                        item-text="description_long" item-value="id" prepend-inner-icon="corporate_fare" outlined
                        rounded dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field v-model="newBussiness.description_long" label="Nombre Completo" outlined rounded
                        dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="newBussiness.description_short" label="Alias / Nombre Corto" outlined
                        rounded dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="newBussiness.rnc" label="RNC" outlined rounded dense
                        prepend-inner-icon="fingerprint"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="newBussiness.rnl" label="RNL" outlined rounded dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="4">
                  <div class="text-overline grey--text mb-4 text-center">Logo / Imagen</div>
                  <v-card flat class="image-uploader-card rounded-xl" @click="takeImage()"
                    :class="loading ? 'loading-state' : ''">
                    <v-container fill-height fluid class="pa-0">
                      <v-row align="center" justify="center">
                        <v-col cols="12" class="text-center pa-0">
                          <v-file-input id="fileInput" v-model="url_image" @change="onFileChange" accept="image/*"
                            class="d-none">
                          </v-file-input>

                          <div v-if="!image_storage" class="pa-10">
                            <v-icon size="64" color="primary lighten-3">add_a_photo</v-icon>
                            <div class="mt-2 primary--text font-weight-medium">Subir Imagen</div>
                          </div>
                          <v-img v-else :src="image_storage" width="100%" height="220" contain
                            class="rounded-xl"></v-img>

                          <v-overlay v-if="image_storage" absolute class="rounded-xl" opacity="0.1">
                            <v-btn fab small color="white" @click.stop="removeImage()">
                              <v-icon color="error">delete</v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="pa-6 pt-0">
              <v-spacer></v-spacer>
              <v-btn text color="grey darken-1" @click="close" rounded class="px-6">Cancelar</v-btn>
              <v-btn color="primary" @click="save" :loading="loading" rounded depressed class="px-8 font-weight-bold">
                <v-icon left>save</v-icon> Guardar Unidad
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialogo ARS Plans (Modernizado) -->
        <v-dialog v-model="dialogArs" max-width="800px" transition="dialog-fade-transition">
          <v-card class="modern-card overflow-hidden">
            <v-toolbar flat color="secondary" dark>
              <v-icon class="mr-2">verified_user</v-icon>
              <v-toolbar-title>Configuración de Planes ARS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogArs = false"><v-icon>close</v-icon></v-btn>
            </v-toolbar>

            <v-card-text class="pa-6">
              <v-row align="end" class="mb-6">
                <v-col cols="12" md="4">
                  <v-autocomplete :items="itemsArs" v-model="newArsPlans.id" @change="loadPlans" label="ARS" outlined
                    dense rounded hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete :items="itemsPlans" v-model="newArsPlans.ars_plan_id" :loading="loadingPlans"
                    label="Plan Seleccionado" outlined dense rounded hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="newArsPlans.amount" label="Monto / Costo" type="number" outlined dense rounded
                    hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn color="success" block rounded depressed height="40" @click="addArsPlan()">
                    <v-icon left>add</v-icon> Añadir
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="mb-4"></v-divider>

              <div class="text-subtitle-2 font-weight-bold mb-2 grey--text">Planes Vinculados</div>
              <v-simple-table dense class="modern-table elevation-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">ARS</th>
                      <th class="text-left">PLAN</th>
                      <th class="text-right">MONTO</th>
                      <th class="text-center">ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in arsPlans" :key="index">
                      <td class="font-weight-medium primary--text">{{ item.ars }}</td>
                      <td>{{ item.plan }}</td>
                      <td class="text-right font-weight-bold">${{ parseFloat(item.amount).toFixed(2) }}</td>
                      <td class="text-center">
                        <v-btn icon x-small color="error" @click="arsPlans.splice(index, 1)">
                          <v-icon x-small>delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <tr v-if="arsPlans.length === 0">
                      <td colspan="4" class="text-center py-4 grey--text italic">No hay planes vinculados</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>

            <v-card-actions class="pa-6 pt-0">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="saveArs" rounded depressed class="px-8 font-weight-bold">
                Finalizar Configuración
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialogo Confirmar Eliminacion -->
        <v-dialog v-model="dialogDelete" max-width="450px" transition="dialog-center-transition">
          <v-card class="modern-card pa-4 text-center">
            <v-icon size="64" color="error" class="mb-4">error_outline</v-icon>
            <div class="text-h6 font-weight-bold mb-2">¿Confirmar Eliminación?</div>
            <div class="grey--text mb-6">Esta acción es irreversible y podría afectar otros registros del sistema.</div>
            <v-row justify="center">
              <v-btn color="grey lighten-4" depressed rounded class="mx-2 px-6 grey--text text--darken-2"
                @click="closeDelete">Cancelar</v-btn>
              <v-btn color="error" depressed rounded class="mx-2 px-6" @click="deleteItemConfirm">Sí, Eliminar</v-btn>
            </v-row>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "BussinesUnit",
  data: () => ({
    dialog: false,
    dialogArs: false,
    dialogImage: false,
    loadingPlans: false,
    loading: false,
    itemsBanks: [],
    image_storage: null,
    dialogDelete: false,
    showAddAccount: false,
    headers: [
      { text: "Cod.", align: "start", value: "id" },
      { text: "Compania / Empresa", value: "description_company" },
      { text: "Unidad de Negocio", value: "description_long" },
      { text: "Abreviatura", value: "description_short" },
      { text: "RNC / Identificación", value: "rnc" },
      { text: "Estado", value: "status_id", sortable: true },
      { text: "Actions", value: "actions", sortable: false, align: "end" },
    ],
    arsPlans: [],
    newArsPlans: { id: "", ars_plan_id: "", amount: "" },
    unidad: 0,
    search: "",
    url_image: "",
    itemsPlans: [],
    itemsCompany: [],
    itemsCurrencies: [],
    itemsAccountypes: [],
    bussinessUnit: [],
    newBussiness: {
      id: "",
      company_id: 1,
      rnc: "",
      rnl: "",
      description_short: "",
      description_long: "",
      status_id: "",
      image_storage: "",
    },
    bussiness_account: [],
    accounts: [],
    itemsArs: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Unidad de Negocio" : "Editar Unidad de Negocio";
    },
  },
  watch: {
    dialog(val) { val || this.close(); },
    dialogDelete(val) { val || this.closeDelete(); },
  },
  created() {
    this.initialize();
  },
  methods: {
    takeImage() {
      document.getElementById("fileInput").click();
    },
    imageUrl(image) {
      if (!image) return null;
      // Key de DigitalOcean Spaces (ej: "companies/uuid.png")
      if (typeof image === "string") {
        if (image.startsWith("http")) return image;
        return this.spaces_file_url(image);
      }
      // Registro antiguo de PocketBase u objeto { url, key }
      if (image.url) return image.url;
      if (image.key) return this.spaces_file_url(image.key);
      return this.get_storage(image);
    },
    async initialize() {
      this.loading = true;
      try {
        const result = await Promise.all([
          this.g_bussines(),
          this.g_companies(),
          this.g_Bancos(),
          this.g_type_account(),
          this.g_currencies(),
          this.g_ars(),
          this.api_Get("accounting/accountsUsable"),
        ]);
        this.bussinessUnit = result[0];
        this.itemsCompany = result[1];
        this.itemsBanks = result[2];
        this.itemsAccountypes = result[3];
        this.itemsCurrencies = result[4];
        this.itemsArs = result[5];

        let accounts = await result[6].json();
        this.accounts = accounts.map(item => ({
          text: item.code + " - " + item.name,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        }));
      } catch (e) {
        this.$toast.error("Error cargando datos: " + (e.message || e));
      } finally {
        this.loading = false;
      }
    },
    onFileChange() {
      if (this.url_image) {
        this.image_storage = URL.createObjectURL(this.url_image);
      }
    },
    removeImage() {
      this.image_storage = null;
      this.url_image = null;
      this.newBussiness.image_storage = "";
    },
    openCreateDialog() {
      this.clearData();
      this.dialog = true;
    },
    async editItem(item) {
      this.clearData();
      this.editedIndex = this.bussinessUnit.indexOf(item);
      this.newBussiness = Object.assign({}, item);
      if (this.newBussiness.image_storage) {
        this.image_storage = this.imageUrl(this.newBussiness.image_storage);
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.bussinessUnit.indexOf(item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      try {
        let id = this.bussinessUnit[this.editedIndex].id;
        const response = await this.api_Delete("humanResource/bussinessUnit/" + id);
        if (response.ok) {
          this.bussinessUnit.splice(this.editedIndex, 1);
          this.$toast.success("Unidad eliminada correctamente");
        }
      } catch (e) {
        this.$toast.error("Error al eliminar");
      }
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },
    async save() {
      this.loading = true;
      try {
        // Si el usuario seleccionó una imagen nueva, se sube a DigitalOcean Spaces
        if (this.url_image) {
          const result = await this.upload_to_spaces(this.url_image, "companies");
          if (!result || !result.key) {
            this.$toast.error("Error al subir la imagen: respuesta vacía del servidor");
            this.loading = false;
            return;
          }
          this.newBussiness.image_storage = {
            url: result.url,
            key: result.key,
            name: this.url_image.name,
          };
        }

        let response;
        if (this.editedIndex > -1) {
          response = await this.api_Put("humanResource/bussinessUnit", this.newBussiness);
        } else {
          response = await this.api_Post("humanResource/bussinessUnit", this.newBussiness);
        }

        if (response.ok) {
          this.$toast.success("Unidad guardada exitosamente");
          await this.initialize();
          this.close();
        }
      } catch (err) {
        this.$toast.error("Error al guardar");
      } finally {
        this.loading = false;
      }
    },
    clearData() {
      this.newBussiness = {
        id: "",
        company_id: 1,
        rnc: "",
        rnl: "",
        description_short: "",
        description_long: "",
        status_id: "",
        image_storage: "",
      };
      this.image_storage = null;
      this.url_image = null;
      this.editedIndex = -1;
    },
    async ars(item) {
      this.loadingPlans = true;
      const result = await this.api_Get("humanResource/arsBusinessUnits/" + item.id);
      this.arsPlans = await result.json();
      this.dialogArs = true;
      this.unidad = item.id;
      this.loadingPlans = false;
    },
    async loadPlans() {
      if (!this.newArsPlans.id) return;
      this.loadingPlans = true;
      const result = await this.api_Get("humanResource/arsPlans/" + this.newArsPlans.id);
      this.itemsPlans = await result.json();
      this.loadingPlans = false;
    },
    addArsPlan() {
      if (!this.newArsPlans.id || !this.newArsPlans.ars_plan_id || !this.newArsPlans.amount) {
        return this.warningNotification("Complete todos los campos del plan");
      }
      let arsObj = this.itemsArs.find(e => e.value == this.newArsPlans.id);
      let planObj = this.itemsPlans.find(e => e.value == this.newArsPlans.ars_plan_id);

      this.arsPlans.push({
        ars_plan_id: this.newArsPlans.ars_plan_id,
        amount: this.newArsPlans.amount,
        business_unit_id: this.unidad,
        ars: arsObj.text,
        plan: planObj.text,
        status_id: 1,
        status: true,
      });
      this.newArsPlans = { id: "", ars_plan_id: "", amount: "" };
    },
    async saveArs() {
      try {
        const result = await this.api_Post("payroll/arsPlansInBusinessUnits", {
          plans_data: this.arsPlans,
        });
        if (result.ok) {
          this.$toast.success("Planes actualizados");
          this.dialogArs = false;
        }
      } catch (e) {
        this.$toast.error("Error al guardar planes");
      }
    },
    async toggleStatus(item) {
      this.$set(item, 'loadingStatus', true);
      try {
        const response = await this.api_Put("humanResource/bussinessUnit", item);
        if (response.ok) {
          this.$toast.success(`Unidad ${item.status_id === 1 ? 'activada' : 'desactivada'} correctamente`);
        } else {
          // Revertir en caso de error
          item.status_id = item.status_id === 1 ? 2 : 1;
          this.$toast.error("Error al actualizar estado");
        }
      } catch (e) {
        item.status_id = item.status_id === 1 ? 2 : 1;
        this.$toast.error("Error de conexión");
      } finally {
        item.loadingStatus = false;
      }
    },
  },
};
</script>

<style scoped>
.modern-card {
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(12px);
  overflow: hidden;
}

.page-header {
  border-left: 6px solid #1976d2;
  padding-left: 20px;
}

.search-field {
  max-width: 350px;
}

.modern-table :deep(.v-data-table-header) {
  background-color: #f1f5f9 !important;
}

.modern-table :deep(th) {
  text-transform: uppercase;
  font-size: 0.7rem !important;
  font-weight: 800 !important;
  color: #475569 !important;
  letter-spacing: 0.08em;
  padding: 16px !important;
}

.modern-table :deep(tr:hover) {
  background-color: #f8fafc !important;
}

.image-uploader-card {
  border: 2px dashed #e2e8f0 !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-uploader-card:hover {
  border-color: #1976d2 !important;
  background: #f0f7ff !important;
}

.loading-state {
  pointer-events: none;
  opacity: 0.6;
}
</style>
